/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */
/**
 * <pre><code>Holds error codes - specifies the type of error
 * DEPENDENCY_FAILURE - Failures occurred due to reporting system dependency service failures.
 * DRYAD_DEPENDENCY_FAILURE - Failures occurred due to reporting system dependency Dryad service.
 * INTERNAL_FAILURE - Failures occurred due to any missing data\/unexpected cases in reporting system.
 * CLIENT_FAILURE - Failures occurred due to any client error - Invalid inputs, Not Authorized to access etc.,
 * MISSING_REPORT: Failure occurred because the requested report is not present in source.
 * MISSING_REPORT_RECORD: Failure occurred because the record or entry for a report is not present in the DB.
 * MISSING_REPORT_CONFIGURATION: Failure occurred because the configuration for term is not present.
 * MISSING_VIEW_PERMISSIONS: Failure occurred because the VIEW permissions to perform an action is not
 * present.
 * MISSING_EDIT_PERMISSIONS: Failure occurred because the EDIT permissions to perform an action is not
 * present.
 * Note : To add more error codes when required.
 * <\/code><\/pre>
 **/
export var ErrorCode;
(function (ErrorCode) {
    ErrorCode["DEPENDENCY_FAILURE"] = "DEPENDENCY_FAILURE";
    ErrorCode["DRYAD_DEPENDENCY_FAILURE"] = "DRYAD_DEPENDENCY_FAILURE";
    ErrorCode["INTERNAL_FAILURE"] = "INTERNAL_FAILURE";
    ErrorCode["CLIENT_FAILURE"] = "CLIENT_FAILURE";
    ErrorCode["MISSING_REPORT"] = "MISSING_REPORT";
    ErrorCode["MISSING_REPORT_RECORD"] = "MISSING_REPORT_RECORD";
    ErrorCode["MISSING_REPORT_CONFIGURATION"] = "MISSING_REPORT_CONFIGURATION";
    ErrorCode["MISSING_VIEW_PERMISSIONS"] = "MISSING_VIEW_PERMISSIONS";
    ErrorCode["MISSING_EDIT_PERMISSIONS"] = "MISSING_EDIT_PERMISSIONS";
})(ErrorCode || (ErrorCode = {}));
